<template>
    <div>
        <el-input
            v-if="mode === 'edit'"
            v-model="currentValue"
            :placeholder="placeholder"
            :data-bot="dataBot"
            @change="update"
            @blur="formatAmount"
        >
            <template v-if="numberFormat.currencypos === 'right'" #append>{{ symbol }}</template>
            <template v-if="numberFormat.currencypos === 'left'" #prepend>{{ symbol }}</template>
        </el-input>
        <p v-else>{{ currentValue }} {{ numberFormat.currencysymbol }}</p>
    </div>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: '',
        },
        modelValue: {
            type: [Number, String],
            required: false,
            default: 0,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        symbol: {
            type: String,
            required: false,
            default: window.App.numformat.currencysymbol,
        },
        dataBot: {
            type: String,
            required: false,
            default: '',
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            numberFormat: window.App.numformat,
            currentValue: this.modelValue,
        };
    },
    created() {
        this.currentValue = NumberFormat.formatToDisplay(this.modelValue, window.App.numformat);
    },
    methods: {
        formatAmount() {
            if (!this.currentValue) {
                this.currentValue = 0;
            }
            this.currentValue = NumberFormat.formatToDisplay(this.currentValue, this.numberFormat);
        },
        update(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
};
</script>
